import { useState, useEffect } from 'react';

const STORAGE_KEY = 'baselmitkindern_favorites';

// Module-level singleton state shared across all hook instances
let _favorites = [];
const _listeners = new Set();

// Initialize from localStorage once
try {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) _favorites = JSON.parse(stored);
} catch (e) {}

function notify() {
  _listeners.forEach(fn => fn([..._favorites]));
}

function setFavorites(newFavs) {
  _favorites = newFavs;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(_favorites));
  window.dispatchEvent(new CustomEvent('favoritesUpdated', { detail: { count: _favorites.length } }));
  notify();
}

export function useFavorites() {
  const [favorites, setLocalFavorites] = useState([..._favorites]);

  useEffect(() => {
    const listener = (favs) => setLocalFavorites(favs);
    _listeners.add(listener);
    // Sync on mount in case state changed before this instance subscribed
    setLocalFavorites([..._favorites]);
    return () => _listeners.delete(listener);
  }, []);

  const addFavorite = (activityId) => {
    if (!_favorites.includes(activityId)) {
      setFavorites([..._favorites, activityId]);
      return true;
    }
    return false;
  };

  const removeFavorite = (activityId) => {
    setFavorites(_favorites.filter(id => id !== activityId));
    return true;
  };

  const toggleFavorite = (activityId) => {
    if (_favorites.includes(activityId)) {
      removeFavorite(activityId);
    } else {
      addFavorite(activityId);
    }
  };

  const isFavorite = (activityId) => favorites.includes(activityId);

  return { favorites, addFavorite, removeFavorite, toggleFavorite, isFavorite, isLoaded: true };
}

export default useFavorites;